/* Dansk katalog for locale-no.js (del 6 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'buy.editPurchaseHelp': 'Gemmer ændringerne i det bogførte køb.',
  'adv.tax.choices.title': 'Hvis dette var mit selskab',
  'adv.tax.myRecommendation': 'Min anbefaling:',
  'adv.tax.wait': 'Vent',
  'adv.tax.recommendWait': 'Anbefaling: vent',
  'adv.tax.showCalculation': 'Vis beregning',
  'adv.tax.line.tax': 'Skat',
  'adv.tax.line.liquidity': 'Likviditet',
  'adv.tax.line.netCost': 'Nettoomkostning',
  'adv.tax.fig.taxBaseReduction': 'Reduktion af skattegrundlaget',
  'adv.tax.fig.taxSaving': 'Anslået skattebesparelse',
  'adv.tax.fig.liquidityEffect': 'Likviditetseffekt',
  'adv.tax.fig.netCost': 'Nettoomkostning efter skatteeffekt',
  'adv.tax.rateNote.corporate': 'Skattebesparelsen er beregnet med {pct} % selskabsskat.',
  'adv.tax.rateNote.soleTrader': 'Skattebesparelsen er beregnet med {pct} %, som er Plummes vejledende skattesats for enkeltmandsvirksomheder. Den faktiske marginalskat afhænger af trinnskatt, trygdeavgift og dine personlige forhold.',
  'adv.tax.proposal.taxReserve.title': 'Sæt penge af til skat',
  'adv.tax.proposal.taxReserve.desc': 'Resultatet indtil nu tilsiger, at du bør reservere {amount} før private hævninger eller større køb. Det sænker ikke skatten — det sikrer, at pengene er der, når regningen kommer.',
  'adv.tax.proposal.vatDue.title': 'Moms, der skal dækkes',
  'adv.tax.proposal.vatDue.desc': 'Beregnet moms fra bogførte salg og køb er {amount}. Kontrollér perioden før indberetning.',
  'adv.tax.proposal.buyAssets.title': 'Køb af driftsmidler før årets udgang',
  'adv.tax.proposal.buyAssets.desc': 'Du har {count} planlagt(e) investering(er) på i alt {amount}. Skattetallene nedenfor er en illustration; type driftsmiddel, brug og levetid skal kontrolleres for hvert køb.',
  'adv.tax.proposal.missingVouchers.title': 'Bilag, du mangler',
  'adv.tax.proposal.missingVouchers.desc': '{count} bogførte køb på i alt {amount} mangler bilag. Kontrollér, om hvert køb giver fradrag eller indgående moms.',
  'adv.tax.calc.taxReserveBase': 'Skattebufferen er {pct} % af resultatet indtil nu, minus indbetalt forskudsskat: {amount}.',
  'adv.tax.calc.vatDueBase': 'Udgående moms minus indgående moms i perioden: {amount}.',
  'adv.tax.calc.assetCapitalize': 'Illustrationen behandler {amount} som ét kvalificerende driftsmiddel over grænsen for straksfradrag ({limit}).',
  'adv.tax.calc.assetDirect': 'Illustrationen forudsætter, at købet på {amount} kvalificerer til straksfradrag under grænsen ({limit}).',
  'adv.tax.calc.assetDepreciation': 'Illustration, hvis driftsmidlet hører til saldogruppe d: {pct} % første år = {amount}.',
  'adv.tax.calc.assetSaving': '{reduction} lavere skattegrundlag × {pct} % = {saving} i sparet skat.',
  'adv.tax.calc.voucherBase': '{count} bogførte køb uden bilag, i alt {amount} ekskl. moms. Beløbet er ikke et beregnet fradrag.',
  'adv.tax.calc.voucherSaving': '{amount} i fradrag × {pct} % = {saving} i sparet skat, forudsat at bilagene kommer på plads.',
  'adv.tax.calc.voucherVat': 'Derudover er {vat} i indgående moms i fare uden dokumentation.',
  'adv.tax.choice.buyAssets.q': 'Købe driftsmidlerne før nytår?',
  'adv.tax.choice.buyAssets.reco.wait': 'Vent med købet. Prognosen viser, at bufferen ikke kan bære udbetalingen på {amount} nu. Kontrollér behov og skattemæssig behandling pr. driftsmiddel, før du vælger tidspunkt.',
  'adv.tax.choice.buyAssets.reco.do': 'Bufferen kan bære udbetalingen på {amount}. Gennemfør kun, hvis driftsmidlet er nødvendigt, og kontrollér skattebehandlingen pr. køb. En mulig skattefordel er ikke alene en grund til at købe.',
  'adv.tax.choice.buyAssets.reco.consider': 'Vurdér det sammen med din bogholder. Jeg har ikke nok likviditetsdata til at sige, om bufferen kan bære udbetalingen på {amount} i år.',
  'adv.tax.choice.taxReserve.q': 'Sætte penge af til skat nu?',
  'adv.tax.choice.taxReserve.reco.do': 'Gør det. {amount} er penge, du allerede skylder — de er bare ikke skilt ud endnu. Sætter du dem af nu, slipper du for at finde dem, når fristen kommer.',
  'adv.tax.choice.taxReserve.reco.wait': 'Vent lidt. Bufferen er stram lige nu — men {amount} skal være på plads før fristen.',
  'adv.tax.choice.taxReserve.reco.consider': 'Overvej at sætte {amount} af nu, så pengene er der, når fristen kommer.',
  'adv.tax.choice.missingVouchers.q': 'Rydde op i de manglende bilag?',
  'adv.tax.choice.missingVouchers.reco.do': 'Gør det før periodens udløb. Find de {count} bilag, der mangler, og kontrollér, hvilke køb der faktisk kan give fradrag eller indgående moms.',
  'adv.tax.choice.missingVouchers.reco.wait': 'Tag det før periodens udløb. {count} bilag mangler; vurdér fradragsretten for hvert køb.',
  'adv.tax.choice.missingVouchers.reco.consider': 'Skaf de {count} bilag, der mangler, og vurdér, om købene er fradragsberettigede.',
  'adv.report.emptyTitle': 'Rapporter vises her',
  'adv.report.emptyText': 'Rapportvisningen tilsluttes, når AI-rådgiveren får backend-data.',
  'adv.bench.title': 'Sammenligning med tidligere tal',
  'adv.bench.sub': 'Dine nøgletal mod det valgte sammenligningsgrundlag',
  'adv.bench.help': 'Her ser du dine egne nøgletal mod sidste år eller en anbefalet intern tærskel. Mærket til højre viser, om udviklingen peger den rigtige vej for hvert tal.',
  'adv.bench.rowHelp': 'Din virksomhed: {you} · sammenligning: {avg}. {verdict}{direction}',
  'adv.bench.rowBetter': 'Udviklingen er bedre på dette mål.',
  'adv.bench.rowWorse': 'Dette er et område, du kan se nærmere på.',
  'adv.bench.higherBetter': ' Her er højere bedre.',
  'adv.bench.lowerBetter': ' Her er lavere bedre.',
  'adv.bench.stronger': 'Stærkere',
  'adv.bench.weaker': 'Svagere',
  'adv.bench.you': 'Din virksomhed',
  'adv.bench.comparison': 'Sammenligning',
  'adv.bench.emptyTitle': 'Ingen sammenligning endnu',
  'adv.bench.emptyText': 'Sammenligning kræver nøgletal for det valgte år og et tidligere år eller en intern tærskel.',
  'adv.verdict.tag': 'Hvad sker der lige nu?',
  'adv.verdict.liquidityBufferBreach': 'Beregnet saldo ud fra bogførte tal ligger {shortfall} under bufferen på {buffer} i {month}. Tjek kommende betalinger, før du vælger tiltag.',
  'adv.verdict.liquidityOverdue': 'Forfaldne kundefakturaer på {amount} er ikke registreret som indbetalt. Det kan påvirke likviditeten, selv om den beregnede saldo ligger over bufferen.',
  'adv.verdict.liquidityNoForwardData': 'Denne visning har ingen kommende måneder med beregnet saldo. Åbne poster og bufferen kan stadig følges op.',
  'adv.verdict.liquidityOk': 'Den beregnede saldo ligger over bufferen i de viste måneder. Åbne poster og betalinger, der ikke er registreret, kan ændre billedet.',
  'adv.verdict.costSpike': '{name} er steget {pct} % i forhold til sammenligningsperioden. Det er den omkostning, jeg ville se nærmere på først.',
  'adv.verdict.costUp': 'Omkostningerne er steget {pct} % i forhold til sidste år. Ingen enkeltpost stikker ud, men samlet er udviklingen værd at kigge på.',
  'adv.verdict.costDown': 'Omkostningerne er faldet {pct} % i forhold til sidste år. Det er god omkostningsstyring.',
  'adv.verdict.costFlat': 'Omkostningerne ligger stabilt på {amount}. Intet, der kræver handling nu.',
  'adv.verdict.costNoComparison': 'Du har bogført {amount} i omkostninger. Jeg mangler tal fra sidste år, så jeg kan endnu ikke sige, om udviklingen peger den rigtige vej.',
  'adv.verdict.taxBoth': 'Du har {vat} i moms og {buffer}, der bør sættes til side til skat. Sørg for, at pengene er der, når fristerne kommer.',
  'adv.verdict.taxVat': 'Du har {vat} i moms, der skal dækkes. Sæt beløbet til side før forfald.',
  'adv.verdict.taxBuffer': 'Resultatet tilsiger, at du bør sætte {buffer} til side til skat, før du hæver penge privat.',
  'adv.verdict.taxNothingDue': 'Jeg finder ingen moms eller skattehensættelse, der forfalder nu. Brug fanen som tjekliste før indberetning.',
  'adv.verdict.reportProfit': 'Perioden giver et overskud på {result} — {income} ind og {costs} ud.',
  'adv.verdict.reportLoss': 'Perioden giver et underskud på {result} — {income} ind og {costs} ud.',
  'adv.verdict.benchAllStronger': 'Du ligger stærkere på alle {total} nøgletal, jeg sammenligner. Det er solidt.',
  'adv.verdict.benchMixed': 'Du ligger stærkere på {better} af {total} nøgletal. Resten er der, hvor jeg ville lede efter forbedringer.',
  'adv.verdict.benchAllWeaker': 'Du ligger svagere på alle {total} nøgletal, jeg sammenligner. Start med det, der betyder mest for pengestrømmen.',
  'adv.verdict.benchNoData': 'Jeg mangler endnu grundlag for at sammenligne dine nøgletal.',
  'adv.why.title': 'Hvorfor sker det?',
  'adv.why.liquiditySub': 'Åbne poster og hensættelser, du bør se sammen med den beregnede saldo',
  'adv.liquidity.watchTitle': 'Det holder jeg også øje med',
  'adv.liquidity.watchBelowBuffer': 'Mangler til bufferen i {month}',
  'adv.liquidity.watchAboveBuffer': 'Margin over bufferen i {month}',
  'adv.liquidity.watchNoBalance': 'Ingen kommende måned med beregnet saldo',
  'adv.liquidity.watchReceivables': 'Kundefakturaer, der ikke er forfaldne',
  'adv.liquidity.watchPayables': 'Leverandørfakturaer, der ikke er forfaldne',
  'adv.liquidity.scope': 'Vurderingen bygger på bogførte indtægter og omkostninger, åbne poster og buffergrænsen. Planlagte betalinger, der ikke er registreret i Plumme, er ikke med.',
  'adv.why.costTitle': 'Det lagde jeg mærke til',
  'adv.why.whyOverdueSales': 'Forfaldne kundefakturaer',
  'adv.why.whyOverduePurchases': 'Forfaldne leverandørfakturaer',
  'adv.why.whyPublicDues': 'Moms og skattehensættelse, der forfalder',
  'adv.why.whyCostUp': '{name} — op {pct} % i forhold til sammenligningsperioden',
  'adv.why.whyCostLargest': '{name} — din største omkostningspost',
  'adv.moves.title': 'Hvis det var min virksomhed',
  'adv.moves.liquiditySub': 'Forfaldne poster, kommende moms, prognosebuffer og salgsdokumenter, der kræver opfølgning.',
  'adv.moves.costTitle': 'Muligheder',
  'adv.moves.costSub': 'Penge, du kan hente ind eller stoppe med at bruge',
  'adv.moves.go': 'Åbn',
  'adv.moves.showAll': 'Se alle {count}',
  'adv.moves.count': '{count} stk.',
  'adv.moves.followup': 'Til opfølgning',
  'adv.moves.amount': 'Beløb',
  'adv.moves.moveAcceptedOffer': 'Følg op på accepterede tilbud ({count})',
  'adv.moves.moveAcceptedOffer.note': 'Ingen tilknyttet faktura eller fakturakladde',
  'adv.moves.moveFollowUpOffer': 'Følg op på sendte tilbud ({count})',
  'adv.moves.moveFollowUpOffer.note': 'Venter på svar eller nærmer sig gyldighedsdatoen',
  'adv.moves.moveSendOffer': 'Send ikke-sendte tilbud ({count})',
  'adv.moves.moveSendOffer.note': 'Oprettet, men ikke sendt til kunden',
  'adv.moves.moveOfferDrafts': 'Færdiggør tilbudskladder ({count})',
  'adv.moves.moveOfferDrafts.note': 'Kladder, der ikke er oprettet og sendt',
  'adv.moves.moveInvoiceDrafts': 'Gennemgå fakturakladder ({count})',
  'adv.moves.moveInvoiceDrafts.note': 'Kladder, der har ligget i mindst syv dage',
  'adv.moves.moveChaseOverdue': 'Send rykker for de forfaldne kundefakturaer',
  'adv.moves.moveSetAsideVat': 'Sæt moms til side før forfald',
  'adv.moves.moveBuildBuffer': 'Byg bufferen op før {month}',
  'adv.moves.movePayOverdue': 'Betal de forfaldne leverandørfakturaer',
  'adv.moves.moveReviewCost': 'Gennemgå {name}',
  'adv.moves.moveFixVouchers': 'Upload {count} manglende bilag',
  'adv.moves.moveWatchCosts': 'Ingen omkostningstiltag nødvendige nu',
  'adv.gain.gainCashflow': 'bedre pengestrøm',
  'adv.gain.gainAvoidInterest': 'du undgår morarenter',
  'adv.gain.gainToBuffer': 'mangler til bufferen',
  'adv.gain.gainAvoidFees': 'du undgår gebyrer og rykkere',
  'adv.gain.gainCostIncrease': 'stigningen i forhold til sammenligningsperioden',
  'adv.gain.gainDeductionRisk': 'fradrag, du risikerer at miste uden bilag',
  'adv.gain.gainNoActionNeeded': 'omkostningerne er under kontrol',
  'adv.monitor.title': 'SuperPlumma overvåger',
  'adv.monitor.sub': 'Det tjekker jeg, hver gang tallene ændrer sig',
  'adv.monitor.help': 'De kontroller, SuperPlumma kører automatisk mod regnskabet. Grøn betyder, at kontrollen er i orden nu, gul at noget bør ses på.',
  'adv.monitor.monitorLiquidity': 'Likviditetsbuffer',
  'adv.monitor.monitorOverdueSales': 'Forfaldne kundefakturaer',
  'adv.monitor.monitorOverduePurchases': 'Forfaldne leverandørfakturaer',
  'adv.monitor.monitorVat': 'Moms, der forfalder',
  'adv.monitor.monitorVouchers': 'Bilag på køb',
  'adv.monitor.monitorConcentration': 'Kundeafhængighed',
  'adv.monitor.group.liquidity': 'Likviditet',
  'adv.monitor.group.receivables': 'Indbetalinger',
  'adv.monitor.group.costs': 'Omkostninger og leverandører',
  'adv.monitor.group.tax': 'Skat og frister',
  'adv.monitor.group.quality': 'Bogføringskvalitet',
  'adv.monitor.group.sales': 'Salg og rentabilitet',
  'adv.monitor.detail.liquidityBelow': 'Beregnet saldo ud fra bogførte tal ligger under bufferen på {amount} i måned {month}.',
  'adv.monitor.detail.liquidityOk': 'Beregnet saldo ud fra bogførte tal holder sig over den valgte buffer i de kommende måneder.',
  'adv.monitor.detail.liquidityNoData': 'Ingen kommende måneder med beregnet saldo i den valgte periode.',
  'adv.monitor.detail.receivablesOld': '{amount} er forfaldent; det ældste krav er {days} dage gammelt.',
  'adv.monitor.detail.receivablesOverdue': '{amount} i tilgodehavender fra salg er forfaldent.',
  'adv.monitor.detail.receivablesSlower': 'Kunderne bruger i gennemsnit {days} dage mere på at betale.',
  'adv.monitor.detail.receivablesOk': 'Ingen forfaldne tilgodehavender fra salg kræver opfølgning.',
  'adv.monitor.detail.receivablesNoData': 'Der er ikke nok salgsdata til at vurdere indbetalingerne.',
  'adv.monitor.detail.costsSupplierOverdue': '{amount} i leverandørkrav er forfaldent.',
  'adv.monitor.detail.costsSupplierDependency': '{name} står for {pct} % af årets omkostninger.',
  'adv.monitor.detail.costsBudgetOver': 'Omkostningerne ligger {pct} % over budget indtil nu.',
  'adv.monitor.detail.costsIncrease': 'Omkostningerne er steget {pct} % i forhold til sammenlignelig periode.',
  'adv.monitor.detail.costsOk': 'Ingen væsentlige omkostnings- eller leverandørafvigelser.',
  'adv.monitor.detail.costsNoData': 'Der er ikke nok omkostningsdata til at vurdere afvigelser.',
  'adv.monitor.detail.taxDeadline': 'Antal frister, der bør følges op: {count}.',
  'adv.monitor.detail.taxVat': 'Beregnet moms, der skal dækkes, er {amount}.',
  'adv.monitor.detail.taxOk': 'Ingen beregnede momsbeløb eller nære frister kræver handling.',
  'adv.monitor.detail.taxNoData': 'Der er ikke nok regnskabsdata til at vurdere moms og skat.',
  'adv.monitor.detail.qualityVouchers': '{count} bogførte køb mangler bilag.',
  'adv.monitor.detail.qualityBank': '{count} banklinjer er ikke færdigafstemt.',
  'adv.monitor.detail.qualityStale': 'Seneste regnskabsaktivitet er {days} dage gammel.',
  'adv.monitor.detail.qualityImportedAggregate': 'Importerede summer kan analyseres, men bilagenes fuldstændighed kan ikke kontrolleres uden de enkelte posteringer.',
  'adv.monitor.detail.qualityNoData': 'Der er ikke nok aktivitet i det valgte år til at vurdere kvaliteten.',
  'adv.monitor.detail.qualityOk': 'Bilag og eventuelle banklinjer ser ryddelige ud.',
  'adv.monitor.detail.salesBudgetBelow': 'Omsætningen ligger {pct} % under budget indtil nu.',
  'adv.monitor.detail.salesRevenueDrop': 'Omsætningen er faldet {pct} % i forhold til sammenlignelig periode.',
  'adv.monitor.detail.salesNegativeMargin': 'Resultatmarginen er {pct} %.',
  'adv.monitor.detail.salesCustomerDependency': '{name} står for {pct} % af årets omsætning.',
  'adv.monitor.detail.salesOk': 'Ingen væsentlige afvigelser i salg eller rentabilitet.',
  'adv.monitor.detail.salesNoData': 'Der er ikke nok salgsdata til at vurdere udviklingen.',
  'adv.conf.buildsOn': 'Bygger på',
  'adv.conf.missing': 'Mangler',
  'adv.conf.nothingYet': 'Ingen bogførte tal endnu',
  'adv.conf.nothingMissing': 'Intet mangler',
  'adv.conf.postedIncome': 'Bogførte indtægter',
  'adv.conf.postedCosts': 'Bogførte omkostninger',
  'adv.conf.openItems': 'Åbne poster',
  'adv.conf.previousYear': 'Sidste års tal',
  'adv.conf.customerSplit': 'Salg pr. kunde',
  'adv.conf.completeVouchers': 'Komplette bilag',
  'adv.conf.importedVoucherDetails': 'Detaljegrundlag for importerede bilag',
  'adv.why.recWhyOverdueCash': 'Pengene er allerede tjent — de er bare ubetalte',
  'adv.why.recWhyOverdueBuffer': 'Prognosen falder under din buffer uden disse indbetalinger',
  'adv.why.recWhyVatDeadline': 'Moms forfalder på fast termin og kan ikke udskydes',
  'adv.why.recWhyVatInterest': 'For sen betaling giver morarenter og gebyr',
  'adv.why.recWhyVoucherDeduction': 'Uden bilag kan fradraget blive underkendt ved kontrol',
  'adv.why.recWhyVoucherAudit': 'Bokføringsloven kræver dokumentation for hver postering',
  'adv.why.recWhyCostGrowth': 'Omkostningerne vokser {pct} % i forhold til sidste år',
  'adv.chat.placeholder': 'Skriv en besked …',
  'adv.chat.send': 'Send',
  'adv.chat.fallbackToast': 'SuperPlumma svarede med lokal reserveløsning.',
  'adv.chat.limitReached': 'Denne samtale har nået grænsen på {max} spørgsmål. Start en ny samtale for at fortsætte.',
  'adv.chat.limitNear': '{left} spørgsmål tilbage i denne samtale.',
  'adv.chat.newChat': 'Start ny samtale',
  'adv.chat.business.intro': 'Hej! Jeg er SuperPlumma, din økonomiske rådgiver. Jeg har gennemgået virksomhedens regnskab og kan svare på det, du undrer dig over — likviditet, omkostninger, skat eller sundhedsscoren. Hvad vil du se nærmere på?',
  'adv.chat.business.sugg1': 'Hvordan kan jeg forbedre likviditeten?',
  'adv.chat.business.sugg2': 'Hvor kan jeg skære i omkostningerne?',
  'adv.chat.business.sugg3': 'Forklar min sundhedsscore',
  'adv.chat.business.sugg4': 'Hvornår forfalder momsen?',
  'adv.chat.private.intro': 'Hej! Jeg er SuperPlumma, din private rådgiver. Jeg har kigget på din økonomi og kan hjælpe dig med opsparing, lån, fradrag, pension og skattemeldingen. Hvad har du på hjerte?',
  'adv.chat.private.sugg1': 'Hvor kan jeg spare penge?',
  'adv.chat.private.sugg2': 'Bør jeg omlægge boliglånet?',
  'adv.chat.private.sugg3': 'Hvilke fradrag kan jeg få?',
  'adv.chat.private.sugg4': 'Hvordan ser det ud med min pension?',
  'adv.reply.private.saving': 'Jeg har brug for tilknyttede data om privatøkonomien, før jeg kan pege på konkrete besparelser. Når data er klar, kan jeg vise faste træk, abonnementer og usædvanlige omkostninger.',
  'adv.reply.private.loan': 'Jeg kan vurdere lån og rente, når lånedata er tilknyttet. Indtil videre bør konkrete låneråd kontrolleres mod banktilbud og den faktiske låneaftale.',
  'adv.reply.private.tax': 'Jeg kan hjælpe med skat, når relevante private transaktioner og fradragsgrundlag er tilknyttet. Brug svaret som kontrolpunkt, ikke som bindende skatterådgivning.',
  'adv.reply.private.pension': 'Pensionsråd kræver indkomst-, pensions- og opsparingsdata. Når det er tilgængeligt, kan jeg vise udviklingen og mulige justeringer.',
  'adv.reply.private.score': 'Privat sundhedsscore beregnes, når privatøkonomimodellen har nok data.',
  'adv.reply.private.default': 'Godt spørgsmål! Jeg kan hjælpe dig med opsparing, lån, fradrag, pension og skattemeldingen. Hvad vil du starte med?',
  'adv.reply.business.liquidity': 'Jeg har brug for adgang til backend-rådgiveren for at give konkrete likviditetstal. Når den er tilgængelig, bruger jeg åbne kundetilgodehavender, leverandørkrav og rapporterede månedsdata.',
  'adv.reply.business.costs': 'Omkostningsråd bør bygge på bogførte omkostningslinjer og sammenligning med tidligere år. Prøv igen, når SuperPlumma-backend er tilgængelig.',
  'adv.reply.business.tax': 'Skat og moms skal beregnes ud fra bogførte tal. Jeg giver ikke konkrete beløb i den lokale reserveløsning, men backend-rådgiveren kan hente dette fra rapportmodellen.',
  'adv.reply.business.score': 'Sundhedsscoren beregnes ud fra faktisk likviditet, vækst, rentabilitet og stabilitet, når rådgivermodellen er tilgængelig.',
  'adv.reply.business.invoices': 'Fakturaopfølgning kræver åbne fakturaer fra backend. Når data er klar, kan jeg vise, hvilke poster der bør følges op først.',
  'adv.reply.business.default': 'Godt spørgsmål. Jeg kan svare konkret, når SuperPlumma-backend er tilgængelig; den lokale reserveløsning viser kun generelle råd uden regnskabstal.',
  'trv.sub': 'Rejseafregninger, kørselsgodtgørelse og udlæg indsendt fra medarbejderportalen. Private udlæg går til næste lønudbetaling — firmakort/driftskonto bogføres direkte og holdes uden for lønnen.',
  'trv.allEmployees': 'Alle medarbejdere',
  'trv.searchPh': 'Søg på rejse, formål eller medarbejder',
  'trv.noTravel': 'Ingen rejser her endnu',
  'trv.noTravelHelp': 'Når medarbejdere indsender rejser eller udlæg fra medarbejderportalen, vises de her.',
  'trv.backToOverview': 'Tilbage til oversigten',
  'trv.approveTravel': 'Godkend rejse',
  'trv.trips': 'Kørsler',
  'trv.tripsHelp': 'Kilometergodtgørelse efter statens sats.',
  'trv.noTrips': 'Ingen kørsler registreret.',
  'trv.expenseHelp': 'Private udlæg refunderes via lønnen. Firmakort/driftskonto bogføres direkte.',
  'trv.noExpenses': 'Ingen udlæg registreret.',
  'trv.toPayroll': 'Til lønudbetaling',
  'trv.mileageAllowance': 'Kørselsgodtgørelse',
  'trv.tollsPrivate': 'Vejafgifter (privat)',
  'trv.privateExpenses': 'Private udlæg',
  'trv.postingSuggestion': 'Forslag til bogføring',
  'trv.owedToEmployee': 'Skyldig løn / refusion til ansat',
  'trv.previewComing': 'Forhåndsvisning af rejseafregning og bilag kommer her.',
  'trv.privateRefundOf': 'Privat refusion på',
  'trv.reasonShownToEmployee': 'Begrundelsen vises for den ansatte i medarbejderportalen.',
  'trv.reason': 'Begrundelse',
  'trv.whatMustBeFixed': 'Hvad skal rettes, før rejsen eller udlægget kan godkendes?',
  'trv.subShort': 'Rejseafregninger, kørselsgodtgørelse og udlæg knyttet til ansatte. Private udlæg går til næste lønudbetaling - firmakort/driftskonto bogføres direkte og holdes uden for lønnen.',
  'trv.newTravel': 'Ny rejse',
  'trv.getStarted': 'Registrer en rejse eller et udlæg for at komme i gang.',
  'trv.submitTravel': 'Indsend rejse',
  'trv.reject': 'Afvis',
  'trv.accommodation': 'Overnatning',
  'trv.subsistenceHelp': 'Diæter (kostgodtgørelse) ved overnatning beregnes efter statens satser og udbetales skattefrit til den ansatte.',
  'trv.noAccommodation': 'Ingen overnatning registreret.',
  'trv.subsistenceOvernight': 'Diæter (overnatning)',
  'trv.optionalNotePh': 'Valgfri note, projekt eller reference',
  'trv.editTravel': 'Ret rejse',
  'trv.pickDate': 'Vælg dato',
  'trv.route': 'Strækning',
  'trv.kilometreCount': 'Antal kilometer',
  'trv.sameRouteReturn': 'Brug samme strækning på retur',
  'trv.pickVehicle': 'Vælg køretøj',
  'trv.tollsNok': 'Vejafgifter (NOK)',
  'trv.paymentMethod': 'Betalingsmetode',
  'trv.companyCardOperating': 'Firmakort (driftskonto)',
  'trv.vatOnReceipt': 'Moms på kvitteringen',
  'trv.vatNone': 'Ingen / intet fradrag',
  'trv.enterPassengerName': 'Angiv passagerens navn',
  'trv.enterKilometres': 'Udfyld antal kilometer',
  'trv.kmWithTrailer': 'Kilometer med trailer',
  'trv.kmForestRoad': 'Kilometer på skov- og arbejdsvej',
  'trv.newStay': 'Nyt ophold',
  'trv.stayType': 'Type ophold',
  'trv.otherAccommodationCooking': 'Anden overnatning m. kogemuligheder',
  'trv.mealsPaidYourself': 'Måltider, du selv betalte',
  'trv.pickForWholeStay': 'Vælg for hele opholdet',
  'trv.breakfast': 'Morgenmad',
  'trv.lunch': 'Frokost',
  'trv.dinner': 'Aftensmad',
  'trv.vehicle': 'Køretøj',
  'trv.paymentMethod2': 'Betalingsform',
  'trv.requiredBeforeRegister': 'Beskrivelse, beløb og mindst ét bilag kræves, før du kan registrere.',
  'trv.companyCardDirectHelp': 'Firmakort/driftskonto bogføres direkte og holdes uden for lønudbetalingen.',
  'registry.toggle': 'Søg i Brreg',
  'registry.toggleHelp': 'Foreslår virksomheder, mens du skriver. Slå fra for privatkunder.',
  'registry.searching': 'Søger i Brreg...',
  'registry.needNineDigits': 'Skriv 9 cifre for at søge org.nr. i Brreg.',
  'registry.noHits': 'Ingen resultater i Brreg.',
  'registry.failed': 'BRREG-opslag mislykkedes.',
  'sup.invoices': 'Leverandørfakturaer',
  'sup.invoicesHelp': 'Alle fakturaer og kreditnotaer fra denne leverandør. »Ikke betalt« er åben leverandørgæld, »Betalt« er afregnet, og en kreditnota er en tilbagebetaling/rettelse fra leverandøren.',
  'sup.noInvoicesMatch': 'Ingen leverandørfakturaer passede til filteret.',
  'sup.seeVoucher': 'Se bilag',
  'sup.goTo': 'Gå til',
  'sup.number': 'Leverandørnr.',
  'sup.numberShort': 'Lev.nr.',
  'sup.numberPh': 'F.eks. 20001',
  'sup.name': 'Leverandørnavn',
  'sup.emailPh': 'faktura@leverandor.no',
  'sup.addressPh': 'Gadeadresse, postnr. og by',
  'sup.searchPh': 'Søg i leverandører ...',
  'sup.searchListPh': 'Søg på leverandør eller beløb',
  'sup.searchHelp': 'Søg efter en leverandør på nummer, navn, organisationsnummer, kontaktoplysninger, samlet køb eller udestående beløb.',
  'sup.totalPurchases': 'Samlet køb',
  'sup.mergeTitle': 'Flet leverandører',
  'sup.mergeIntro': 'Har du oprettet den samme leverandør to gange?',
  'sup.mergeSwap': 'Skift, hvilken leverandør der bevares',
  'sup.sameInvoiceNumber': 'Det samme fakturanummer er registreret på begge leverandører.',
  'sup.checkDuplicates': 'Kontrollér, at købene ikke er dubletter, før du fletter.',
  'sup.exportCsv': 'Leverandører CSV',
  'sup.exportExcel': 'Leverandører Excel',
  'sup.ledgerCsv': 'Kreditorer CSV',
  'sup.ledgerExcel': 'Kreditorer Excel',
  'sup.whoYouBuyFrom': 'Hvem du køber fra',
  'sup.outstandingHelp': 'Hvor meget du skylder leverandøren lige nu — summen af ubetalte leverandørfakturaer (leverandørgæld). Står der 0, har du ingen åbne fakturaer hos denne leverandør.',
  'sup.totalPurchasesHelp': 'Det samlede beløb, du har købt for hos denne leverandør i alt — både betalte og ubetalte fakturaer.',
  'sup.balance.youOwe': 'Du skylder leverandøren {amount}',
  'sup.balance.supplierOwes': 'Leverandøren skylder dig {amount}',
  'sup.ledger.empty': 'Ingen kreditorposter endnu.',
  'sup.status.posted': 'Bogført',
  'sup.status.partial': 'Delvist betalt',
  'sup.status.unpaid': 'Ikke betalt',
  'sup.status.credit': 'Kreditnota',
  'sup.status.invoice': 'Faktura',
  'sup.filter.all': 'Alle',
  'sup.sheet.suppliers': 'Leverandører',
  'sup.sheet.ledger': 'Kreditorer',
  'sup.export.internalId': 'Internt ID',
  'sup.ledger.type.supplierInvoice': 'Leverandørfaktura',
  'sup.ledger.type.payment': 'Leverandørbetaling',
  'sup.ledger.type.importedInvoice': 'Importeret leverandørfaktura',
  'sup.excelUnavailable': 'Excel-eksport er ikke tilgængelig endnu.',
  'sup.voucherUnderTransactions': 'Bilaget ligger under Transaktioner.',
  'sup.voucherFallbackName': 'Bilag',
  'sup.voucherViewNotConnected': 'Visning af bilag er ikke koblet til backend.',
  'sup.cannotShowVoucher': 'Bilaget kunne ikke vises.',
  'sup.cannotFetchVoucher': 'Bilaget kunne ikke hentes fra backend.',
  'sup.previewVoucher': 'Forhåndsvis bilaget',
  'sup.noVoucherUploaded': 'Intet bilag uploadet',
  'sup.nameRequired': 'Leverandørnavn skal udfyldes.',
  'sup.saveFailed': 'Leverandøren kunne ikke gemmes.',
  'sup.editTitle': 'Opdatér leverandør',
  'sup.updateAction': 'Opdatér',
  'sup.saveAction': 'Gem',
  'sup.defaultDueDaysLabel': 'Standard betalingsfrist (dage)',
  'sup.defaultCostAccountLabel': 'Standard omkostningskonto',
  'sup.defaultSettlementAccountLabel': 'Standard betalingskonto',
  'sup.costAccountPh': 'f.eks. 6300',
  'sup.settlementAccountPh': 'f.eks. 1920',
  'sup.mergePickerPlaceholder': 'Vælg leverandør ...',
  'sup.mergeKeep': 'Bevares',
  'sup.mergeRemove': 'Flettes og fjernes',
  'sup.mergeSuccess': 'Leverandørerne blev flettet',
  'sup.mergeBackendNotReady': 'Fletning i backend er ikke klar.',
  'sup.mergeFailed': 'Leverandørerne kunne ikke flettes.',
  'sup.merging': 'Fletter...',
  'sup.mergeAction': 'Flet leverandører',
  'sup.mergeModalIntro': 'Vælg dubletten. Køb og fakturaer flyttes til den leverandør, der bevares, og den anden leverandør fjernes.',
  'sup.mergeFieldLabel': 'Hvilken leverandør er den samme som {name}?',
  'sup.mergeMoreInvoiceNumbers': '+ {count} flere fakturanumre',
  'sup.noSuppliersToExport': 'Ingen leverandører at eksportere',
  'sup.exportListFailed': 'Leverandørlisten kunne ikke eksporteres.',
  'sup.exportListDone': 'Leverandørlisten er downloadet',
  'sup.noLedgerRowsToExport': 'Ingen kreditorposter at eksportere',
  'sup.exportLedgerFailed': 'Kreditorlisten kunne ikke eksporteres.',
  'sup.exportLedgerDone': 'Kreditorlisten er downloadet',
  'sup.updated': 'Leverandøren er opdateret',
  'sup.saved': 'Leverandøren er gemt',
  'sup.archived': 'Leverandøren er flyttet til arkivet',
  'sup.archiveFailed': 'Leverandøren kunne ikke arkiveres.',
  'sup.reopened': 'Leverandøren er genåbnet',
  'sup.reopenFailed': 'Leverandøren kunne ikke genåbnes.',
  'sup.titleHelp': 'Leverandørregistret samler alle, du køber fra — navn, org.nr., kontaktoplysninger og kontonummer til udbetalinger. Når du registrerer køb og leverandørfakturaer, knyttes de til den rigtige leverandør her.',
  'sup.downloadHelp': 'Download leverandørlisten eller kreditorlisten som CSV eller Excel.',
  'sup.addHelp': 'Opret en ny leverandør manuelt. Udfyld navn og org.nr., så kan du knytte køb og fakturaer til den. Nye leverandører oprettes ofte automatisk, når du bogfører et køb.',
  'sup.col.name': 'Leverandør',
  'sup.reopenAction': 'Genåbn',
  'sup.archiveAction': 'Arkivér',
  'sup.mergeHelp': 'Flet to leverandører til én. Nyttigt, når den samme leverandør er registreret flere gange. Al historik og alle fakturaer flyttes til den leverandør, du bevarer.',
  'sup.enterName': 'Indtast leverandørnavn.',
  'sup.registryNotConnected': 'Leverandørregistret er ikke forbundet til backend.',
  'sup.saveSuccess': 'Leverandøren er gemt.',
  'sup.saveSupplierAction': 'Gem leverandør',
  'bg.stepsHelp': 'Trinene fører dig gennem én opgave ad gangen. Et flueben betyder, at kontrollen er færdig; et tal viser, hvad der stadig kræver opmærksomhed.',
});
